export const MigrosEngagementSmallTheme = {
  name: 'Migros-Engagement Small Theme',
  themeId: 'migrosEngagementSmall',
  colors: {
    brand: {
      primary: {
        100: '#C4390A'
      },
      secondary: {
        100: '#C4390A'
      },
      accent: {
        100: '#9B2700'
      },
      text: {
        100: '#1C1C1C'
      },
      grayout: {
        100: '#DDDDDD'
      }
    },
    tints: {
      gray: {
        10: '#F5F5F5',
        25: '#F5F5F5',
        50: '#939393',
        60: '#696969',
        75: '#696969',
        80: '#3C3C3C',
        90: '#3C3C3C',
        100: '#3C3C3C'
      }
    }
  },
  fonts: {
    families: {
      heading: '"Helvetica-Display", "Helvetica", arial, sans-serif',
      subHeading: '"Helvetica-Display", "Helvetica", arial, sans-serif',
      text: '"Helvetica-Text", "Helvetica", Arial, sans-serif',
      condensed: '"Helvetica-Text", "Helvetica", Arial, sans-serif',
      display: '"Helvetica-Text", "Helvetica", Arial, sans-serif',
      articleText: '"Helvetica-Text", "Helvetica", Arial, sans-serif',
      articleHeading: '"Helvetica-Text", "Helvetica", Arial, sans-serif',
      articlePrice: '"Helvetica-Text", "Helvetica", Arial, sans-serif'
    },
    sizes: {
      text: {
        tiny: '10px',
        xsmall: '12px',
        small: '14px',
        medium: '16px',
        large: '18px',
        xlarge: '22px',
        huge: '26px'
      },
      heading: {
        tiny: '14px',
        xsmall: '18px',
        small: '22px',
        medium: '26px',
        large: '32px',
        xlarge: '36px',
        huge: '40px'
      }
    }
  },
  borderRadiuses: {
    xsmall: '2px',
    small: '4px',
    medium: '40px',
    large: '50px'
  }
};